import { render } from "./HelpTip.vue?vue&type=template&id=bee8d408"
import script from "./HelpTip.vue?vue&type=script&lang=js"
export * from "./HelpTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__